export default __webpack_public_path__ + "static/media/Girls_Head_Bounce.8b8049c9.svg";